var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3636 10.7273H17.4545V11.8182H16.3636V10.7273Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.27273V21.6364H24V2H3.27273L0 5.27273ZM8.72621 5.27283V7.45461H15.2717V5.27283H8.72621ZM6.54545 8.54545L4.36364 10.7272V16.1818H7.63636V14H16.3636V16.1818H19.6364V10.7272L17.4545 8.54545H6.54545ZM7.63636 18.3637L9.81818 15.0909H14.1818L16.3636 18.3637H7.63636Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintBarcode);
export default __webpack_public_path__ + "static/media/PrintBarcode.c1d81c13b1d9c6ca422b17f08c6a4639.svg";
export { ForwardRef as ReactComponent };